/* BYRD EDGE theme JS — no dependencies */
(function () {
  'use strict';

  /* Sticky header shadow */
  var header = document.querySelector('.site-header');
  if (header) {
    window.addEventListener('scroll', function () {
      header.classList.toggle('is-stuck', window.scrollY > 4);
    }, { passive: true });
  }

  /* Mobile menu */
  var toggle = document.querySelector('.menu-toggle');
  var nav = document.querySelector('.site-nav--left');
  if (toggle && nav) {
    toggle.addEventListener('click', function () {
      var open = nav.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  /* Reveal on scroll */
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('is-in');
          io.unobserve(e.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px' });
    document.querySelectorAll('.reveal').forEach(function (el) { io.observe(el); });
  } else {
    document.querySelectorAll('.reveal').forEach(function (el) { el.classList.add('is-in'); });
  }

  /* Sticky mobile add-to-cart: show once the main buy button scrolls out of view */
  var atcBar = document.getElementById('StickyAtc');
  var buyBtn = document.querySelector('[data-main-atc]');
  if (atcBar && buyBtn && 'IntersectionObserver' in window) {
    var atcObserver = new IntersectionObserver(function (entries) {
      atcBar.classList.toggle('is-visible', !entries[0].isIntersecting);
    }, { threshold: 0 });
    atcObserver.observe(buyBtn);
    var stickyTrigger = atcBar.querySelector('[data-sticky-trigger]');
    if (stickyTrigger) {
      stickyTrigger.addEventListener('click', function () {
        buyBtn.closest('form') ? buyBtn.click() : null;
      });
    }
  }

  /* Variant select -> update price + url (single option product forms) */
  document.querySelectorAll('[data-product-form]').forEach(function (form) {
    var json = form.querySelector('[data-product-json]');
    if (!json) return;
    var product;
    try { product = JSON.parse(json.textContent); } catch (e) { return; }
    var selects = form.querySelectorAll('[data-option-select]');
    var idInput = form.querySelector('input[name="id"]');
    var priceEl = document.querySelector('[data-price-now]');
    var wasEl = document.querySelector('[data-price-was]');
    var money = function (cents) {
      return '$' + (cents / 100).toFixed(2).replace(/\.00$/, '');
    };
    function currentVariant() {
      var opts = Array.prototype.map.call(selects, function (s) { return s.value; });
      return product.variants.find(function (v) {
        return v.options.every(function (o, i) { return o === opts[i]; });
      });
    }
    selects.forEach(function (s) {
      s.addEventListener('change', function () {
        var v = currentVariant();
        if (!v) return;
        idInput.value = v.id;
        if (priceEl) priceEl.textContent = money(v.price);
        if (wasEl) {
          wasEl.textContent = v.compare_at_price > v.price ? money(v.compare_at_price) : '';
        }
        var btn = form.querySelector('[data-main-atc]');
        if (btn) {
          btn.disabled = !v.available;
          btn.textContent = v.available ? btn.getAttribute('data-label-add') : btn.getAttribute('data-label-sold');
        }
      });
    });
  });

  /* Cart quantity +/- */
  document.querySelectorAll('.cart-line__qty').forEach(function (qty) {
    var input = qty.querySelector('input');
    qty.querySelectorAll('button').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var v = parseInt(input.value, 10) || 0;
        input.value = Math.max(0, v + (btn.dataset.dir === 'up' ? 1 : -1));
        input.form && input.form.submit();
      });
    });
  });
})();
